import * as React from 'react';
import { Subheading, Paragraph } from 'components/src/typography';
import NextLink from 'components/src/link/NextLink';
import { PackageCardFieldsFragment } from '../../../@types/generated';
import { getOr } from '@/utils/options';
import ISKFormat from '../common/ISKFormat';
import typewriter, { PackageCardButtonClickedType, Source } from '@/analytics/segment';
import ProductItems from './ProductItems';
import Icons from './Icons';
import PrimaryButton from './PrimaryButton';

type Props = {
  data: PackageCardFieldsFragment;
  hasDisclaimer?: boolean;
  source?: Source;
};

const PackageCard = ({ data, hasDisclaimer = false, source }: Props) => {
  return (
    <div className="col-span-6 flex flex-col justify-between gap-y-16 rounded-28 bg-white-100 px-24 py-16 shadow-card lg:col-span-4 xl:col-span-3">
      <div className="flex flex-col gap-16">
        {data.heading && (
          <Subheading bold classes="min-h-[56px] text-lg-fixed text-black-100">
            {data.heading}
          </Subheading>
        )}
        <ProductItems productItems={data.productItems} />
        <Icons title={data.iconContainerTitle} modal={data.iconContainerModal} icons={data.iconsCollection} />
      </div>
      <div className="flex flex-col gap-16">
        {data.price && (
          <div className="flex pl-16">
            <ISKFormat
              value={data.price}
              renderText={(value) => (
                <Subheading bold classes="text-black-100">
                  {value}
                </Subheading>
              )}
            />
            <div className="ml-8 mt-auto flex">
              {data.priceSuffix && (
                <Paragraph variant="small" classes="mb-[3px] inline">
                  {data.priceSuffix}
                </Paragraph>
              )}
              {hasDisclaimer && (
                <Paragraph classes="inline text-red-100" variant="small">
                  {'*'}
                </Paragraph>
              )}
            </div>
          </div>
        )}
        <div className="grid gap-y-8 text-center">
          <PrimaryButton buttonData={data.button} packageName={data.heading} source={source} />
          <span className="my-8">
            {data.link?.title && data.link.uri && (
              <NextLink
                label={data.link.title}
                href={data.link.uri}
                size="large"
                onClick={() => {
                  typewriter.packageCardButtonClicked({
                    package: getOr(data.heading, 'Ekkert nafn á pakka'),
                    title: getOr(data.link?.title, 'Enginn texti í takka'),
                    type: PackageCardButtonClickedType.Secondary,
                    ...(Boolean(source) && { source }),
                  });
                }}
              />
            )}
          </span>
        </div>
      </div>
    </div>
  );
};
export default PackageCard;
